module.exports = __webpack_public_path__ + "static/media/discover.5f8ac492.svg";